// @flow

import jsonpatch from "json-patch";

import type { SchemaTest } from "@modules/settings/types";

export function test(settings: Object, tests: Array<SchemaTest>): boolean {
  try {
    return !!jsonpatch.apply(
      settings,
      tests.map(t => ({ ...t, op: "test" })),
    );
  } catch (e) {
    return false;
  }
}

export function filter(schema: Object, filters: Array<string>): Object {
  return schema
    ? Object.keys(schema).reduce((acc, k) => {
        if (filters.indexOf(k) !== -1) {
          return acc;
        }

        if (typeof schema[k] === "object" && !Array.isArray(schema[k])) {
          return { ...acc, [k]: filter(schema[k], filters) };
        }

        if (typeof schema[k] === "object" && Array.isArray(schema[k])) {
          if (k === "required") {
            return { ...acc, [k]: schema[k].filter(s => filters.indexOf(s) === -1) };
          }

          return { ...acc, [k]: schema[k].map(p => filter(p, filters)) };
        }

        return { ...acc, [k]: schema[k] };
      }, {})
    : {};
}
